module.exports = "build/assets/personShadow.374dfa7b.png";